import type { ResponseData_PagedResponse_AllApplicationsDocumentResponse } from '@acme/api';
import { ApplicationService } from '@acme/api/client';
import { PaginatedList } from '@shared/ui/paginatedList';
import { useMemo } from 'react';
import { DocumentsEmptyState } from '../../lib/documentsemptystate';
import type { ApplicationDocumentsFiltersValue } from '../../lib/filtertypes';
import { getDocumentDateRange } from '../../lib/filtertypes';
import { ApplicationDocumentsTable } from './table';

type ApplicationDocumentsListProps = {
  filters: ApplicationDocumentsFiltersValue;
};

export const ApplicationDocumentsList = ({
  filters,
}: ApplicationDocumentsListProps) => {
  const params = useMemo(() => {
    const { dateFrom, dateTo } = getDocumentDateRange(filters.period);
    return {
      documentTypeIds: filters.documentTypeId
        ? [filters.documentTypeId]
        : undefined,
      dateFrom,
      dateTo,
      search: filters.search.trim() || undefined,
    };
  }, [filters]);

  return (
    <PaginatedList
      method={ApplicationService.getApiV1ApplicationDocument}
      params={params}
      extract={(
        response: ResponseData_PagedResponse_AllApplicationsDocumentResponse
      ) => ({
        items: response.data?.items ?? [],
        totalCount: response.data?.totalCount ?? 0,
      })}
      loadingFallback={
        <div className="bg-white border border-gray-200 rounded-lg p-12 text-center text-gray-500">
          Загрузка…
        </div>
      }
    >
      {(items) =>
        items.length === 0 ? (
          <DocumentsEmptyState />
        ) : (
          <ApplicationDocumentsTable documents={items} />
        )
      }
    </PaginatedList>
  );
};
